export default __webpack_public_path__ + "static/media/register_new.9e04ca2f.svg";